import { render, staticRenderFns } from "./SciApplicationDetailTemplate.vue?vue&type=template&id=7dab3052"
import script from "./SciApplicationDetailTemplate.vue?vue&type=script&lang=js"
export * from "./SciApplicationDetailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports